import { render, staticRenderFns } from "./ExportFile.vue?vue&type=template&id=c6226c5c&scoped=true&"
import script from "./ExportFile.vue?vue&type=script&lang=js&"
export * from "./ExportFile.vue?vue&type=script&lang=js&"
import style0 from "./ExportFile.vue?vue&type=style&index=0&id=c6226c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6226c5c",
  null
  
)

export default component.exports